// src/i18n/en/users.ts

export const users = {
  name: 'User |||| Users',
  
  fields: {
    id: 'ID',
    username: 'Username',
    email: 'Email',
    name: 'Name',
    firstName: 'First name',
    lastName: 'Last name',
    role: 'Role',
    password: 'Password',
    temporaryPassword: 'Temporary password',
    currentPassword: 'Current password',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    status: 'Status',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    lastLogin: 'Last login',
    lastLoginAt: 'Last login',
    hotelId: 'Property',
    groupId: 'Group',
    assignedGroups: 'Assigned groups',
    assignedHotels: 'Assigned properties',
    assignments: 'Assignments',
    allAccess: 'Full access',
    noAssignments: 'No assignments',
    groupsCount: '%{smart_count} group |||| %{smart_count} groups',
    hotelsCount: '%{smart_count} property |||| %{smart_count} properties',
    isActive: 'Active',
    isInactive: 'Inactive',
  },
  
  roles: {
    SuperAdmin: 'Super Administrator',
    superAdmin: 'Super Administrator',
    Admin: 'Administrator',
    admin: 'Administrator',
    GroupAdmin: 'Group Administrator',
    groupAdmin: 'Group Administrator',
    HotelAdmin: 'Property Administrator',
    hotelAdmin: 'Property Administrator',
    Viewer: 'Viewer',
    viewer: 'Viewer',
    Receptionist: 'Receptionist',
    receptionist: 'Receptionist',
    User: 'User',
  },
  
  list: {
    title: 'Users',
    search: 'Search by name or email',
    loading: 'Loading users...',
    empty: 'No users',
  },
  
  create: {
    title: 'Create User',
    subtitle: 'Fill in the new user details',
  },
  
  edit: {
    title: 'Edit User',
    subtitle: 'Modify user details',
  },
  
  sections: {
    basic_info: 'Basic information',
    assignments: 'Assignments',
    assignments_subtitle: 'Select the properties or groups the user will have access to',
    change_password: 'Change password',
    reset_password: 'Reset password',
  },

  menu: {
    change_password: 'Change Password',
    profile: 'Profile',
    settings: 'Settings',
    account: 'Account',
  },
  
  actions: {
    change_password: 'Change password',
    reset_password: 'Reset password',
    activate: 'Activate',
    deactivate: 'Deactivate',
    add_group_hotels: 'Add all',
    impersonate: 'Impersonate user',
  },
  
  validation: {
    email_required: 'Email is required',
    email_invalid: 'Invalid email',
    name_required: 'Name is required',
    firstName_required: 'First name is required',
    lastName_required: 'Last name is required',
    name_min_length: 'Must be at least 2 characters',
    name_max_length: 'Cannot exceed 100 characters',
    password_required: 'Password is required',
    password_min_length: 'Password must be at least 8 characters',
    temporary_password_helper: 'Minimum 8 characters. The user will be required to change it on first login',
    external_login_helper: 'The user will sign in with their corporate identity provider',
    current_password_required: 'Current password is required',
    confirm_password_required: 'You must confirm the new password',
    passwords_not_match: 'Passwords do not match',
    role_required: 'Role is required',
    role_helper: 'Select the user access level',
    groups_helper: 'Groups the user will have access to',
    hotels_helper: 'Properties the user will have access to',
    groups_required_for_role: 'You must assign at least one group for this role',
    hotels_required_for_role: 'You must assign at least one property for this role',
    select_group_first: 'Select a group',
    group_hotels_added: '%{count} property from the group has been added |||| %{count} properties from the group have been added',
    group_no_hotels: 'The selected group has no properties',
  },
  
  messages: {
    session_expired: 'Session expired',
    password_changed: 'Password changed successfully',
    password_change_error: 'Error changing password',
    password_change_success: 'Password changed successfully',
    invalid_current_password: 'Current password is incorrect',
    password_requirements: 'Password must be at least 8 characters',
    user_created: 'User created successfully',
    user_updated: 'User updated successfully',
    user_deleted: 'User deleted successfully',
    create_success: 'User created successfully',
    create_error: 'Error creating user',
    update_success: 'User updated successfully',
    update_error: 'Error updating user',
    delete_success: 'User deleted successfully',
    delete_error: 'Error deleting user',
    delete_confirm: 'Delete user?',
    user_not_found: 'User not found',
    email_already_exists: 'A user with this email already exists',
    superadmin_access: 'Super Admins have access to all properties and groups',
    temporary_password_info: 'A temporary password will be set. The user will need to change it on first login.',
    external_login_info: 'The user will not have a password of their own. They will sign in with their corporate identity provider.',
    use_external_login: 'Sign in with their corporate identity provider',
    password_reset_success: 'Temporary password set successfully',
    password_reset_error: 'Error resetting password',
    self_role_change: 'You cannot change your own role',
    self_deactivation: 'You cannot deactivate your own account',
    superadmin_management_denied: 'Only staff managers can manage SuperAdmins',
    activate_success: 'Insight access activated successfully',
    deactivate_confirm: 'Deactivate Insight access?',
    deactivate_content: '%{name} will no longer be able to sign in to Insight. Their account and their access to other applications do not change. You can activate it again at any time.',
    deactivate_success: 'Insight access deactivated successfully',
    account_disabled: 'This user\'s account is disabled for every application. To enable it again, contact Roommatik support.',
    user_deactivated: 'This user is deactivated. Activate it before editing it.',
    activate_error: 'Error activating user',
    saving_user: 'Saving user...',
    activating_user: 'Activating user...',
    deactivating_user: 'Deactivating user...',
  },
};

export default users;